import { StepsViewModeType } from '@shared/Enums/StepsViewModeEnum';

const HOME_MODULE_ROOT = '/home';
const TEMPLATE_MODULE_ROOT = '/template';
const PROJECT_ASSISTANCE_MODULE_ROOT = `${HOME_MODULE_ROOT}/project_assistance`;

export const ROUTES = {
    ROOT: '/',
    NOT_FOUND: '*',

    HOME: HOME_MODULE_ROOT,
    BOM: `${HOME_MODULE_ROOT}/bom`,
    TEMPLATES: `${HOME_MODULE_ROOT}/templates`,
    TEMPLATE_CART: {
        path: `${TEMPLATE_MODULE_ROOT}/cart/:tempId`,
        getPath: (tempId: string) => `${TEMPLATE_MODULE_ROOT}/cart/${tempId}`,
    },

    TEMPLATE_INFO: {
        path: `${TEMPLATE_MODULE_ROOT}/:tempId`,
        getPath: (tempId: string) => `${TEMPLATE_MODULE_ROOT}/${tempId}`,
    },

    PROJECT_ASSISTANCE_LAYOUT: `${PROJECT_ASSISTANCE_MODULE_ROOT}/*`,

    STEP1: {
        path: `create_new_project/:viewMode/:projectId?`,
        getPath: (viewMode: StepsViewModeType, projectId?: string | null) =>
            `${PROJECT_ASSISTANCE_MODULE_ROOT}/create_new_project/${viewMode}/${projectId ?? ''}`,
    },

    STEP2: {
        path: `step2/:viewMode/:projectId?`,
        getPath: (viewMode: StepsViewModeType, projectId?: string | null) =>
            `${PROJECT_ASSISTANCE_MODULE_ROOT}/step2/${viewMode}/${projectId ?? ''}`,
    },

    STEP2_SELECT_ITEMS: {
        path: `step2/itemType/:itemTypeId/:viewMode/:projectId?`,
        getPath: (
            viewMode: StepsViewModeType,
            projectId: string | null,
            itemTypeId: string
        ) =>
            `${PROJECT_ASSISTANCE_MODULE_ROOT}/step2/itemType/${itemTypeId}/${viewMode}/${projectId ?? ''}`,
    },

    STEP3: {
        path: `step3/:viewMode/:projectId?`,
        getPath: (viewMode: StepsViewModeType, projectId?: string | null) =>
            `${PROJECT_ASSISTANCE_MODULE_ROOT}/step3/${viewMode}/${projectId ?? ''}`,
    },
} as const;
